// extracted by mini-css-extract-plugin
export default {"card":"X4-z"};